import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {
  SuggestionsList,
  SuggestionsListVariant
} from 'components/DestinationPickerOverlay/SuggestionsList'
import {OnDestinationChangeParams, RecentSearchParams} from 'hooks/searchBox'
import {getIsRtlLanguage} from 'modules/meta/selectors'

import {Popover, PopoverPlacement} from '@vio/atlas/Popover'

interface Props {
  isOpen: boolean
  onClose: (e: MouseEvent) => void
  onForceClosePopover?: () => void
  onChange: (params: OnDestinationChangeParams) => void
  onRecentSearchSelected: (params: RecentSearchParams) => void
  onSuggestionSelected: () => void
  onNearbyPropertiesSuggestionSelected: () => void
  anchorRef: React.RefObject<HTMLElement>
  verticalOffset?: number
}

const CONTENT_WIDTH = 360

const PopoverContent = styled.div`
  width: ${CONTENT_WIDTH}px;
`

export const DestinationPickerPopover = ({
  isOpen,
  onClose,
  onForceClosePopover,
  onChange,
  onRecentSearchSelected,
  onSuggestionSelected,
  anchorRef,
  verticalOffset,
  onNearbyPropertiesSuggestionSelected
}: Props) => {
  const isRtl = useSelector(getIsRtlLanguage)
  return (
    <Popover
      isOpen={isOpen}
      anchorRef={anchorRef}
      onOutsideClick={onClose}
      verticalOffset={verticalOffset}
      placement={
        isRtl ? PopoverPlacement.BottomRight : PopoverPlacement.BottomLeft
      }
    >
      <PopoverContent>
        <SuggestionsList
          listType={SuggestionsListVariant.Popover}
          onChange={onChange}
          onSuggestionSelected={onSuggestionSelected}
          onRecentSearchSelected={onRecentSearchSelected}
          onNearbyPropertiesSuggestionSelected={
            onNearbyPropertiesSuggestionSelected
          }
          onClose={onForceClosePopover}
        />
      </PopoverContent>
    </Popover>
  )
}
